module.exports = __webpack_public_path__ + "img/foot_udnie.0f2e4ec1.jpg";